import { isSSR } from "@website/utils/is-ssr";

export const BASE_URL_PROFILE =
  process.env.NEXT_PUBLIC_BASE_URL_PROFILE || `${getPlatformHost()}/profile`;

function getPlatformHost() {
  if (process.env.NEXT_PUBLIC_BASE_URL_PLATFORM) {
    return process.env.NEXT_PUBLIC_BASE_URL_PLATFORM;
  }
  if (isSSR()) return "https://platform-api.snapptrip.com";
  const { protocol, hostname } = window.location;

  const parts = hostname.split(".");
  if (parts.length > 2) {
    parts.shift();
  }
  const newDomain = parts.join(".");

  return `${protocol}//platform-api.${newDomain}`;
}
